import React from 'react';
import { Grid } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { FormInfoInput, SimpleButton } from '../../../components';
import { PaymentMethod } from '../../../types/items';
import useStyles from './styles';
import { getMonthYearDate } from '../../../utility/billing';
import { selectIsCurrentUser } from '../../../store/modules/users/selectors';

type Props = {
  paymentMethod: PaymentMethod | null;
  changePaymentMethod: () => void;
  loading: boolean;
};

const PaymentMethodView = ({ paymentMethod, changePaymentMethod, loading }: Props) => {
  const classes = useStyles();
  const expDate = paymentMethod ? getMonthYearDate(paymentMethod) : '';
  const canEdit = useSelector(selectIsCurrentUser);

  if (!loading && !paymentMethod && canEdit) {
    return (
      <SimpleButton onClick={changePaymentMethod}>Add Card</SimpleButton>
    );
  }

  return (
    <Grid container spacing={4}>
      <Grid item container spacing={2} xs={12}>
        <Grid item lg={3} md={3} sm={6} xs={12}>
          <FormInfoInput
            label="Card Number"
            value={`**** **** **** ${paymentMethod?.last_four_digits || '- - - -'}`}
          />
        </Grid>
        <Grid item lg={2} md={2} sm={6} xs={12}>
          <FormInfoInput
            label="Expiration (MM/YY)"
            value={expDate}
          />
        </Grid>
      </Grid>
      <Grid item container spacing={2} xs={12}>
        <Grid item lg={2} md={3} xs={12}>
          <FormInfoInput
            label="CVC/CVV"
            value="***"
          />
        </Grid>
        <Grid item lg={2} md={2} sm={6} xs={12}>
          <FormInfoInput
            label="Zip Code"
            value={paymentMethod?.zip || ''}
          />
        </Grid>
      </Grid>
      {canEdit
      && (
        <Grid item xs={12}>
          <div className={classes.buttonPanel}>

            <SimpleButton onClick={changePaymentMethod}>
              Change Card
            </SimpleButton>

          </div>
        </Grid>
      )}
    </Grid>
  );
};

export default PaymentMethodView;
